import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getInitials(nameOrFirst?: string, lastName?: string) {
  if (lastName) {
    return ((nameOrFirst?.[0] || "") + (lastName?.[0] || "")).toUpperCase()
  }
  const name = nameOrFirst || ""
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2)
}

/**
 * Format seconds to a readable time string
 * @param seconds - Time in seconds
 * @returns Formatted string like "2m 30s", "1h 15m", "45s"
 */
export function formatTime(seconds: number): string {
    if (seconds <= 0) return "0s";

    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
        return mins > 0 ? `${hours}h ${mins}m` : `${hours}h 00m`;
    }
    if (mins > 0) {
        return secs > 0 ? `${mins}m ${secs.toString().padStart(2, '0')}s` : `${mins}m 00s`;
    }
    return `${secs}s`;
}

/**
 * Format a date string to a readable format
 * @param dateString - ISO date string
 * @returns Formatted string like "1 Jun • 2:30 PM"
 */
export function formatAnalyticsDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const time = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    return `${day} ${month} • ${time}`;
}
